export default "__VITE_ASSET__CHwOcMRa__"